module.exports = {
    baseUrl: "https://portalapi.x-lingtong.com",
    baseUrl2: 'https://res.x-lingtong.com/api/',
    requestTimeOut: 5000,
    signKey: "3a91ca99a9497bd1b5edd352e78bd7a5",
    signKey2:'sChGwktY11eId678BN4F3HfVJg7Tyl86',
    schoolId: 1000
}